<template>
  <v-container fluid grid-list-md>
    <v-dialog v-model="imageDialog" max-width="100%" scrollable>
      <v-card class="mx-auto">
        <v-card-title style="font-weight: bold; font-size: 1.5em;">Visualização de imagem</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-img :src="img.src" contain class="grey darken-4"></v-img>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" @click="imageDialog = false">FECHAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Dialog para confirmação de exclusão-->
    <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
    <v-dialog v-model="emailDialog" @keydown.enter="sendEmail" @keydown.esc="emailDialog = false" max-width="300px" scrollable>
      <v-card>
        <v-card-text justify-center>
          <p class="text-md-center">Deseja realmente enviar essa listagem para todos o participantes?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" flat color="primary" @click.native="sendEmail">Confirmar</v-btn>
          <v-btn class="mx-0" flat @click.native="emailDialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Index-->
    <v-layout wrap justify-center align-center>
      <v-flex xs12 lg4>
        <span class="headline">{{translate('table.' + entity + '.title')[1]}}</span>
      </v-flex>
      <v-flex xs12 sm6 lg4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs2 sm2 lg2>
        <v-tooltip bottom>
          <v-btn flat icon color="blue" @click.native="emailDialog = true"
                  :disabled="task_shared"
                  slot="activator">
            <v-icon large>mail</v-icon>
          </v-btn>
          <span>Enviar listagem para os participantes</span>
        </v-tooltip>
      </v-flex>
      <v-flex xs10 sm4 lg2 class="text-xs-right">
        <v-btn color="primary" @click="create" class="mb-4" :disabled="task_shared">
          {{this.translate('system.button.add.title')}}
          <v-icon dark> {{this.translate('system.button.add.icon')}}</v-icon>
        </v-btn>
      </v-flex>
      <v-layout row>
        <v-flex xs12>
          <div v-if="filteredComments.length > 0">
          <v-card wrap justify-center align-center v-for="item in filteredComments" :key="item.id" class="mb-2" style="word-break: break-all;">
              <v-card-title style="padding-bottom: 0px; padding-top: 0px" primary-title>
                <div class="body-2">
                  <v-tooltip top>
                    <v-checkbox
                      :disabled="task_shared"
                      slot="activator"
                      v-model="item.done"
                      @click.native="editValue(entity,item,translate('table.' + entity + '.title')[0])"
                    ></v-checkbox>
                    <span>Concluído</span>
                  </v-tooltip>
                </div>
                <div class="subheading" style="font-weight: bold">{{item.id_text}}</div>
                <div v-if="item.user" class="caption pa-2">{{ item.user.id_text + (item.company_id !== task.company_id ? (' ('+item.company.id_text+')') : '')}}</div>
                <v-menu
                  left
                  nudge-top="8"
                  content-class="elevation-0 menu_content"
                  transition="slide-x-reverse-transition"
                  :offset-x="true"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-on="on" absolute right fab small v-model="fab" slot="activator" icon class="mx-0">
                      <v-icon medium>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-tooltip bottom>
                    <v-btn slot="activator" small color="grey lighten-4" fab class="mx-0" @click="editItem(item)" :disabled="task_shared">
                      <v-icon color="teal">edit</v-icon>
                    </v-btn>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-btn slot="activator" small color="grey lighten-4" fab class="mx-0" @click="dialogDelete(item)" :disabled="task_shared || (!task.crud_access && item.user_id !== $auth.user().id)">
                      <v-icon color="pink">delete</v-icon>
                    </v-btn>
                    <span>Excluir</span>
                  </v-tooltip>
                </v-menu>
              </v-card-title>
              <v-card-text style="padding: 10px">
                <div style="overflow-x: wrap; overflow-wrap: break-word; word-wrap: break-word; hyphens: auto; overflow: auto;" class="checklistDescription" v-html="item.description"></div>
              </v-card-text>
            </v-card>
          </div>
          <div v-else>
            <v-card class="mb-2">
              <v-card-text style="padding: 10px">
                <p class="text-xs-center">{{emptyTable}}</p>
              </v-card-text>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-layout>

    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
      <v-card>
        <v-card-title primary-title>
          <span class="headline">{{formTitle}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="padding: 0px">
          <v-form v-model="valid" @keyup.native.esc="close(400)" @keyup.native.ctrl.enter="saveChecklist()" ref="form">
            <v-layout wrap justify-start align-center>
              <v-text-field class="mx-2" maxlength="190" counter="190" ref="autofocus" :label="translate('table.' + entity + '.field.id_text')" v-model="editedItem.id_text" :rules="requiredRule(translate('table.' + entity + '.field.id_text'))" @keyup.native.enter="$refs.editor.focus(0)"></v-text-field>
              <v-flex xs12>
                <v-form @keyup.native.esc="modal = false">
                  <v-layout wrap justify-center align-center>
                    <v-flex xs12>
                        <p-text-editor ref="editor" @change="(val) => {this.editedItem.description = val}" :height="'90%'"></p-text-editor>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="saveChecklist()">Salvar</v-btn>
          <v-btn class="mx-0" :loading="loading" @click.native="close(400)">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style>
  #editor img {
    width: 250px;
    cursor: zoom-in;
  }

  .checklistDescription img {
    max-width: 350px;
    cursor: zoom-in;
  }

  .menu_content {
    padding: 0 10px 10px 10px;
  }

  @media (max-width: 1024px) {
    .checklistDescription img {
      max-width: 100%;
    }
  }

</style>

<script>
  import crud from './../../mixin/crud'
  import rules from './../../mixin/rules'
  import imageCompress from './../../mixin/imageCompress'
  import PConfirm from './../shared/PConfirm'
  import PTextEditor from './../shared/PTextEditor'

  export default {
    mixins: [crud, rules, imageCompress],
    components: {
      PConfirm, PTextEditor
    },
    name: 'TaskChecklist',
    props: {
      task: Object,
      tab: String,
      task_shared: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      entity: 'task_checklist',
      search: '',
      fab: null,
      imageDialog: false,
      emailDialog: false,
      img: '',
      loading: false
    }),
    created () {
      this.items = this.task.checklists
      this.editedItem = {task_id: this.task.id, description: '', id_text: ''}
      this.defaultItem = {task_id: this.task.id, description: '', id_text: ''}
    },
    mounted: function () {
      this.$emit('itemsLength', this.items.length)
      this.addImageListener(document.querySelectorAll('.checklistDescription'))
    },
    methods: {
      afterEditItem () {
        this.$refs.editor.setValue(this.editedItem.description)
        this.$refs.editor.refresh()
      },
      afterCreate () {
        this.$refs.editor.refresh(500)
      },
      afterInsert (res) {
        this.$emit('itemsLength', this.items.length)
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'checklists',
          responseEvent: 'addSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
        //! CORREÇÃO DE SET TIME OUT PENDENTE...
        setTimeout(() => {
          this.addImageListener(document.querySelectorAll('.checklistDescription'))
        }, 400)
      },
      afterUpdate (res) {
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'checklists',
          responseEvent: 'editSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
        setTimeout(() => {
          this.addImageListener(document.querySelectorAll('.checklistDescription'))
        }, 400)
      },
      // Socket usado quando altera o done do checklist pela tela de consulta
      afterEditValue (res) {
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'checklists',
          responseEvent: 'editSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
      },
      afterDelete (res) {
        this.$emit('itemsLength', this.items.length)
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'checklists',
          responseEvent: 'deleteSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
        setTimeout(() => {
          this.addImageListener(document.querySelectorAll('.checklistDescription'))
        }, 400)
      },
      afterClose () {
        this.$refs.editor.setValue('')
      },
      saveChecklist () {
        this.$store.commit('loader/change_dialog', true)
        this.loading = true
        setTimeout(() => {
          this.editedItem.description = this.$refs.editor.getValue()
          // convertido o comentario agora para base64 para armazenagem no servido
          this.imgsCompressAndBase64(this.editedItem.description).then(res => {
            this.editedItem.description = res
            this.$store.commit('loader/change_dialog', false)
            this.loading = false
            this.save()
          }, err => {
            this.$store.commit('loader/change_dialog', false)
            this.loading = false
            console.log(err)
            this.$store.commit('snackbar/change_values', {
              text: 'Erro ao salvar listagem!',
              color: 'error',
              dialog: true
            })
          })
        }, 500)
        if (this.editedItem.done !== true) {
          this.editedItem.done = false
        }
      },
      sendEmail () {
        this.$store.commit('loader/change_dialog', true)
        this.$http.post('api/taskChecklistEmail', {id: this.task.id}).then(
          (res) => {
            this.emailDialog = false
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Resumo(s) enviado(s) com sucesso!',
              color: 'success',
              dialog: true
            })
          },
          err => {
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Erro no envio do(s) resumo(s)!',
              color: 'error',
              dialog: true
            })
            console.log('Controller Error ' + err)
          })
      }
    },
    computed: {
      filteredComments () {
        let fieldSearch = ['id_text', 'done']
        return this.items.filter(i => (
          fieldSearch.some(j => {
            return i[j] ? i[j].toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').match(this.search.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) : false
          })
        ))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/details/TaskChecklist.vue